import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useInput } from "../utils/useInputHook";
import { register } from "../api/auth";
import { useAlert } from "react-alert";
import { Paper, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import validateEmail from '../utils/validateEmail';
import { AccountAccessHelp } from "../components/AccountAccesHelp"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    paper: {
        padding: theme.spacing(2, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(5, 1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function SignUp() {
    const classes = useStyles();
    const alert = useAlert();

    const [loading, setLoading] = useState(false);
    const [userRegistered, setUserRegistered] = useState(false);
    const { value: username, bind: bindUsername } = useInput('');
    const { value: email, bind: bindEmail } = useInput('');
    const { value: password, bind: bindPassword } = useInput('');
    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();

        if (loading) {
            return;
        }
        if (!username) {
            alert.show("Username cannot be empty");
            return;
        }
        if (!email) {
            alert.show("Email cannot be empty");
            return;
        }
        if (!validateEmail(email)){
            alert.show("Please enter a valid email");
            return;
        }
        if (!password) {
            alert.show("Password cannot be empty");
            return;
        }
        try {
            setLoading(true);
            await register({ username, email, password });
            setUserRegistered(true);
        } catch (error) {
            alert.show(error.toString())
        } finally {
            setLoading(false);
        }
    }
    if (userRegistered) {
        return (
            <Redirect to="/login" />
        )
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.wrapper}>
            <Paper className={classes.paper} elevation={4}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign up
                </Typography>
                <form className={classes.form} onSubmit={handleLogin} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="username">Username *</InputLabel>
                                <OutlinedInput
                                    name="username"
                                    required
                                    fullWidth
                                    disabled={loading}
                                    id="username"
                                    label="Username *"
                                    {...bindUsername}
                                    autoFocus
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="email">Email *</InputLabel>
                                <OutlinedInput
                                    name="email"
                                    required
                                    fullWidth
                                    disabled={loading}
                                    id="username"
                                    label="Email *"
                                    {...bindEmail}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="password">Password *</InputLabel>
                                <OutlinedInput
                                    variant="outlined"
                                    required
                                    disabled={loading}
                                    fullWidth
                                    {...bindPassword}
                                    name="password"
                                    label="Password *"
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    autoComplete="current-password"
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => setShowPassword(s => !s)}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {loading ? <CircularProgress color="inherit" className={classes.circularProgress} size={20} /> : 'Sign up'}
                    </Button>
                    <AccountAccessHelp
                        redirectTo="/login"
                        text="Already have an account? Sign in"
                    />
                </form>
            </Paper>
        </Container>
    );
}
